export interface FaqItem {
  q: string;
  a: string;
}

export const siteInfo = {
  name: "51瓜网",
  slogan: "不想漏瓜，一个入口看齐",
  desc: "聚合影视、综艺、明星动态与娱乐热点的吃瓜资讯入口。",
  email: "hello@51gua.example.com",
};

export const navItems = [
  { key: "drama", name: "影视热剧", icon: "ri-film-line" },
  { key: "variety", name: "综艺现场", icon: "ri-mic-line" },
  { key: "star", name: "明星动态", icon: "ri-user-star-line" },
  { key: "music", name: "音乐舞台", icon: "ri-music-2-line" },
  { key: "hot", name: "热点话题", icon: "ri-fire-line" },
];

export const hotWords = [
  "影视热剧盘点",
  "综艺名场面",
  "演唱会经济",
  "明星近况",
  "追剧社交",
  "音乐现场",
  "二创版权",
  "剧集售后",
  "治愈系都市剧",
  "户外真人秀",
];

export const testimonials = [
  {
    name: "追剧多年的小林",
    role: "剧集爱好者",
    avatar: "https://readdy.ai/api/search-image?query=flat%20minimalist%20avatar%20illustration%20of%20a%20friendly%20young%20woman%20in%20warm%20terracotta%20tones%20on%20cream%20background%2C%20soft%20rounded%20shapes%2C%20clean%20modern%20style&width=400&height=400&seq=gua-avatar-01&orientation=squarish",
    text: "以前追热点要开好几个App来回切，自从把51瓜网当首页，早上刷一遍就把当天剧集和综艺的重点都抓住了，省了不少时间。",
  },
  {
    name: "爱跑现场的阿哲",
    role: "音乐live爱好者",
    avatar: "https://readdy.ai/api/search-image?query=flat%20minimalist%20avatar%20illustration%20of%20a%20cheerful%20young%20man%20in%20warm%20amber%20tones%20on%20cream%20background%2C%20soft%20rounded%20shapes%2C%20clean%20modern%20style&width=400&height=400&seq=gua-avatar-02&orientation=squarish",
    text: "上面整理的演出和音乐趋势内容很对我的胃口，能及时看到现场音乐的新动向，比自己在论坛里大海捞针强多了。",
  },
  {
    name: "业余影评人Momo",
    role: "内容创作者",
    avatar: "https://readdy.ai/api/search-image?query=flat%20minimalist%20avatar%20illustration%20of%20a%20thoughtful%20creative%20person%20with%20glasses%20in%20warm%20green%20and%20cream%20tones%2C%20soft%20rounded%20shapes%2C%20clean%20modern%20style&width=400&height=400&seq=gua-avatar-03&orientation=squarish",
    text: "做内容最怕没选题。51瓜网的分类整理帮我快速扫到行业热点和讨论方向，写东西的思路顺了很多。",
  },
];

export const faqs: FaqItem[] = [
  {
    q: "51瓜网主要是做什么的？",
    a: "51瓜网是一个娱乐吃瓜资讯的聚合入口，把影视热剧、综艺现场、明星动态、音乐舞台与热点话题等内容汇总到一个页面里，方便访客快速浏览当天值得关注的资讯与盘点，减少在多个平台来回跳转的时间。",
  },
  {
    q: "网站内容多久更新一次？",
    a: "我们会结合当下的热门影视、综艺与音乐动态持续整理和更新内容。进入资料库后可以按分类查看不同方向的最新盘点与资讯，热门话题板块会优先展示当下讨论度较高的内容。",
  },
  {
    q: "我想投稿或提供线索，该如何联系？",
    a: "欢迎通过页面底部的联系邮箱与我们沟通。你可以分享正在追的剧、想看的盘点方向或行业观察，我们会认真阅读每一条来信，并从中筛选适合整理成内容的话题。",
  },
  {
    q: "资料库的分类是怎样划分的？",
    a: "资料库主要按内容方向划分为影视热剧、综艺现场、明星动态、音乐舞台与热点话题几大类。你可以在资料库页面顶部切换分类，也可以使用搜索快速定位感兴趣的关键词。",
  },
  {
    q: "网站会保留历史热点吗？",
    a: "会的。我们倾向于把热点做成可回看的盘点与资料，而非只呈现转瞬即逝的碎片。许多剧集、综艺与行业话题的内容会作为长期资料沉淀，方便后续按需查阅。",
  },
  {
    q: "如何更快地找到想看的内容？",
    a: "你可以通过首页顶部的分类导航直接进入对应板块，也可以在资料库中使用搜索框输入关键词。此外，热点话题栏会整理当下的热门讨论，是快速了解当天动态的入口。",
  },
];